(function () {
  'use strict';
  // Native anchors and Shopify forms continue to work without JavaScript.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-service-package]');
    if (!link) return;
    var packageField = document.getElementById('BriefPackage');
    var purposeField = document.getElementById('BriefPurpose');
    if (packageField) packageField.value = link.getAttribute('data-service-package');
    if (purposeField) purposeField.value = 'Package inquiry';
  });
})();
